import axios from 'axios'
// import store from '@/store/'

const env = (process.env.NODE_ENV === 'production')

const config = () => {
  // const port = store.getters.theApis.fdc.sitePort
  // return {
  //   // url: env ? 'http://' + store.getters.theApis.fdc.siteIp : 'http://localhost',
  //   url: env ? ((process.env.VUE_APP_HTTPS_ENABLE === 'true' ? 'https://' : 'http://') + store.getters.theApis.fdc.siteIp) : 'http://10.250.172.47',
  //   port: env ? port : '15012'
  // }
  return {
    // url: env ? 'http://' + store.getters.theApis.fdc.siteIp : 'http://localhost',
    url: env ? 'https://fdc-api.brique.kr' : 'http://localhost',
    port: env ? '' : ':'.concat('20004')
  }
}

export default {
  // Parameter Manager
  getParam: async (payload) => {
    try {
      // let response = await axios.get(config().url + ':' + config().port + '/fdc/eis/param/one', { params: payload })
      let response = await axios.get(config().url + config().port + '/fdc/eis/param/one', { params: payload })
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  },
  // Virtual Parameter
  virtualParamValidation: async (payload) => {
    try {
      // let response = await axios.post(config().url + ':' + config().port + '/fdc/eis/virtual-param/validation', payload)
      let response = await axios.post(config().url + config().port + '/fdc/eis/virtual-param/validation', payload)
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  },
  createVirtualParam: async (payload) => {
    try {
      // let response = await axios.post(config().url + ':' + config().port + '/fdc/eis/virtual-param/insert', payload)
      let response = await axios.post(config().url + config().port + '/fdc/eis/virtual-param/insert', payload)
      return response
    } catch (error) {
      console.log(error)
    }
  },
  updateVirtualParam: async (payload) => {
    try {
      // let response = await axios.post(config().url + ':' + config().port + '/fdc/eis/virtual-param/update', payload)
      let response = await axios.post(config().url + config().port + '/fdc/eis/virtual-param/update', payload)
      return response
    } catch (error) {
      console.log(error)
    }
  },
  // CODE
  // step list 조회 (중복 제거)
  stepListForEqps: async (payload) => {
    try {
      // let response = await axios.get(config().url + ':' + config().port + '/fdc/eis/step/list-for-eqps', { params: payload })
      let response = await axios.get(config().url + config().port + '/fdc/eis/step/list-for-eqps', { params: payload })
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  }
}
